(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bbjn-search]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const input = root.querySelector('[data-bbjn-search-input]');
      const panel = root.querySelector('[data-bbjn-suggestions]');
      const status = root.querySelector('[data-bbjn-search-status]');
      const form = root.querySelector('form');
      let timer, controller, sequence = 0;
      const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      const safeURL = (value, image = false) => {
        try { const url = new URL(value, location.origin); return (image ? url.protocol === 'https:' : url.origin === location.origin) ? url.href : null; } catch { return null; }
      };
      input.addEventListener('input', () => {
        clearTimeout(timer); controller?.abort(); const ticket = ++sequence;
        const q = input.value.trim(); close(); status.textContent = '';
        if (q.length < 2) return;
        timer = setTimeout(async () => {
          controller = new AbortController();
          try {
            const base = window.Shopify?.routes?.root || '/';
            const url = new URL(`${base}search/suggest.json`, location.origin);
            url.searchParams.set('q', q); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '5');
            const response = await fetch(url, { signal: controller.signal });
            if (!response.ok) throw new Error('Search suggestions unavailable');
            const data = await response.json();
            if (ticket !== sequence || !root.contains(document.activeElement)) return;
            const products = data.resources?.results?.products || [];
            panel.replaceChildren();
            const heading = document.createElement('p'); heading.textContent = products.length ? 'PRODUCTS' : 'SEARCH RESULTS'; panel.append(heading);
            products.forEach(product => {
              const href = safeURL(product.url); if (!href) return;
              const link = document.createElement('a'); link.href = href;
              const src = safeURL(product.featured_image?.url || product.image, true);
              if (src) { const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 48; img.height = 60; link.append(img); }
              const title = document.createElement('span'); title.textContent = product.title; link.append(title); panel.append(link);
            });
            const all = document.createElement('a'); const full = new URL(form.action); full.searchParams.set('q', q); full.searchParams.set('type', 'product');
            all.href = full.href; all.className = 'bbjn-suggestions-all'; all.textContent = 'See all results →'; panel.append(all);
            panel.hidden = false; input.setAttribute('aria-expanded', 'true'); status.textContent = `${products.length} suggested designs. Tab to browse, or Enter to search.`;
          } catch (error) { if (error.name !== 'AbortError') { close(); status.textContent = 'Press Enter to search the collection.'; } }
        }, 220);
      });
      root.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); input.focus(); } if (event.key === 'ArrowDown' && event.target === input && !panel.hidden) { event.preventDefault(); panel.querySelector('a')?.focus(); } });
      root.addEventListener('focusout', () => setTimeout(() => { if (!root.contains(document.activeElement)) close(); }, 0));
      form.addEventListener('submit', () => { clearTimeout(timer); controller?.abort(); close(); });
    });
    scope.querySelectorAll('[data-bbjn-menu]').forEach(menu => {
      if (menu.dataset.ready) return; menu.dataset.ready = 'true';
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
      menu.addEventListener('focusout', () => setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 0));
    });
    scope.querySelectorAll('[data-bbjn-product-gallery]').forEach(gallery => {
      if (gallery.dataset.thumbsReady) return; gallery.dataset.thumbsReady = 'true';
      const track = gallery.querySelector('[data-bbjn-gallery-track]');
      const buttons = [...gallery.querySelectorAll('[data-bbjn-image-index]')];
      buttons.forEach(button => button.addEventListener('click', () => track.scrollTo({ left: Number(button.dataset.bbjnImageIndex) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })));
      track?.addEventListener('scroll', () => { const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); buttons.forEach((b, i) => i === index ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current')); }, { passive: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
